import styles from "./PagerIndicator.module.css";

interface PagerIndicatorProps {
  count: number;
  currentIndex: number;
  onSelect: (index: number) => void;
}

export function PagerIndicator({
  count,
  currentIndex,
  onSelect,
}: PagerIndicatorProps) {
  return (
    <div className={styles.indicator} aria-label="Välj populärt spel">
      {Array.from({ length: count }, (_, index) => (
        <button
          className={styles.dot}
          type="button"
          key={`page-${index + 1}`}
          aria-label={`Visa spel ${index + 1} av ${count}`}
          aria-current={currentIndex === index ? "true" : undefined}
          onClick={() => onSelect(index)}
        />
      ))}
    </div>
  );
}
